import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, map } from 'rxjs';

import { jobsStaffDdlResponseModel, jobsStateDdlResponseModel, jobsTaskResponseModel, jobscategoryDdlResponseModel, jobscosttypeDdlResponseModel, jobspriorityDdlResponseModel, jobstaskDdlResponseModel, jobstaskstaffDdlResponseModel, userprofileDdlResponseModel } from '../models/jobs';
import { apiEndpoints } from 'src/app/shared/enums/api-endpoints';


@Injectable({
  providedIn: 'root'
})
export class collaborationDdlService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getStateDdl(pagination: any): Observable<jobsStateDdlResponseModel> {
    return this.httpClient.get<jobsStateDdlResponseModel>(apiEndpoints.jobstate + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: jobsStateDdlResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getjob_categoryDdl(pagination: any): Observable<jobscategoryDdlResponseModel> {
    return this.httpClient.get<jobscategoryDdlResponseModel>(apiEndpoints.job_category_ddl + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: jobscategoryDdlResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getjob_priorityDdl(pagination: any): Observable<jobspriorityDdlResponseModel> {
    return this.httpClient.get<jobspriorityDdlResponseModel>(apiEndpoints.job_priority + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: jobspriorityDdlResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getstaff_ddl(pagination: any): Observable<userprofileDdlResponseModel> {
    return this.httpClient.get<userprofileDdlResponseModel>(apiEndpoints.staff_ddl + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: userprofileDdlResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getStaffDdl(job_id: any, pagination: any): Observable<jobsStaffDdlResponseModel> {
    return this.httpClient.get<jobsStaffDdlResponseModel>(apiEndpoints.jobsstaff_ddl + job_id + `/?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: jobsStaffDdlResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getTaskStaffDdl(job_id: any, pagination: any,task_id:any): Observable<jobsStaffDdlResponseModel> {
    return this.httpClient.get<jobsStaffDdlResponseModel>(apiEndpoints.jobsstaff_ddl + job_id + `/?page=${pagination.page}&limit=${pagination.limit}&job_task_id=${task_id}`).pipe(
      map((response: jobsStaffDdlResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobtaskDdl(job_id:string,staff_id: number): Observable<jobstaskDdlResponseModel> {
    return this.httpClient.get<jobstaskDdlResponseModel>(apiEndpoints.jobs_task_ddl + job_id + '/' + staff_id + `/`).pipe(
      map((response: jobstaskDdlResponseModel) =>
        response
      ),
      catchError((error: jobsTaskResponseModel) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  gettask_StaffDdl(job_task_id: any): Observable<jobstaskstaffDdlResponseModel> {
    return this.httpClient.get<jobstaskstaffDdlResponseModel>(apiEndpoints.jobs_task_staff_ddl + job_task_id + `/`).pipe(
      map((response: jobstaskstaffDdlResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getState_typeDdl(pagination: any): Observable<jobsStateDdlResponseModel> {
    return this.httpClient.get<jobsStateDdlResponseModel>(apiEndpoints.jobs_state_type_ddl + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: jobsStateDdlResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getjob_costtypeDdl(pagination: any): Observable<jobscosttypeDdlResponseModel> {
    return this.httpClient.get<jobscosttypeDdlResponseModel>(apiEndpoints.costtype_ddl + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: jobscosttypeDdlResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  timesheetStatus(pagination: any): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.timesheet_status + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  jobsDDl(): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.jobsddl).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: any) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  PhaseDDl(pagination:any,job_id:any): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.job_phase_ddl + `?job_id=${job_id}&page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: any) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }
}
